export const DEFAULT_X = 0;
export const DEFAULT_Y = 0;
export const DEFAULT_BEND = 0;
export const DEFAULT_PATH = '';
export const CRATE_DEFAULT_META = () => ({});
export const DEFAULT_OPACITY = 1;
export const DEFAULT_SCALE_X = 1;
export const DEFAULT_SCALE_Y = 1;
export const CREATE_DEFAULT_PATHS = () => [];
export const DEFAULT_ROTATION = 0;
export const DEFAULT_STROKE = null;
export const DEFAULT_LOCKED = false;
export const CREATE_DEFAULT_CHILDREN = () => [];
export const DEFAULT_HIDDEN = false;
export const DEFAULT_SHADOW = null;
export const DEFAULT_DURATION = -1;
export const DEFAULT_START_TIME = 0;
export const DEFAULT_LINE_HEIGHT = 100;
export const CREATE_DEFAULT_ANIMATIONS = () => [];
export const DEFAULT_LETTER_SPACING = 0;
export const DEFAULT_ALIGNMENT = 'center';
export const DEFAULT_PERSPECTIVE_POINTS = null;
export const DEFAULT_BLEND_MODE = 'source-over';
export const DEFAULT_REPEAT = false;
export const DEFAULT_SPEED = 1;

export const SYSTEM_TEXT = 'system.text';
export const SYSTEM_IMAGE = 'system.image';
export const SYSTEM_SHAPE = 'system.shape';
export const SYSTEM_GROUP = 'system.group';
export const SYSTEM_VIDEO = 'system.video';
export const SYSTEM_AUDIO = 'system.audio';
export const SYSTEM_RENDERER_VERSION = '1.0.0';
export const CREATE_SYSTEM_RENDERER = (packageId: string) => ({
  packageId,
  version: SYSTEM_RENDERER_VERSION,
});
